export class DayLightSavingRule {
  public month: string;
  public nthDayOfWeek: string;

  constructor(month: string, nthDayOfWeek: string) {
    this.month = month;
    this.nthDayOfWeek = nthDayOfWeek;
  }
}
